// extracted by mini-css-extract-plugin
export default {"embed":"embed_embed__m5aFR","active":"embed_active__0F2gX","tabs":"embed_tabs__tGC1Y"};